<template>
  <div class="flex flex-wrap justify-center gap-4 px-4 sm:px-6 lg:px-8">
    <slot />
  </div>
</template>
